<template>
	<el-form :model="customerProduct" :rules="rules" ref="addCustomerProductForm" label-width="120px" size="medium" :status-icon="true" label-suffix=" : ">
		<el-form-item label="产品" prop="productId">
			<el-select v-model="customerProduct.productId" placeholder="请选择" @change="productIdChanged" style="width: 550px;">
				<el-option
					v-for="item in productList"
					:key="item.id"
					:label="item.name"
					:value="item.id">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="分类" prop="productCategoryId" >
			<el-select v-model="customerProduct.productCategoryId" placeholder="请选择" style="width: 550px;">
				<el-option
					v-for="item in currentProduct.categoryList"
					:key="item.id"
					:label="item.name"
					:value="item.id">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="份额" prop="portion">
			<el-input-number v-model="customerProduct.portion" :precision="2"  :step="100" :min="0" style="width: 550px;"></el-input-number>

		</el-form-item>
		<el-form-item label="金额(单位:元)" prop="amount" >
			<el-input-number v-model="customerProduct.amount" :precision="2"  :step="1" :min="0" style="width: 550px;"></el-input-number>
		</el-form-item>
		<el-form-item label="购买日期" prop="buyTime">
			<el-date-picker
				align="right"
				type="date"
				placeholder="购买日期"
				v-model="customerProduct.buyTime"
				value-format="yyyy-MM-dd" style="width: 550px;"
			></el-date-picker>
		</el-form-item>
		<el-form-item label="备注" prop="remark" >
			<el-input type="textarea"  :autosize="{ minRows: 2}" :max="200" v-model="customerProduct.remark"  placeholder="请输入详细描述" style="width: 550px;"></el-input>
		</el-form-item>
		<div style="text-align: right;">
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-form>


</template>

<script>
	import axios from "axios"
	import config from "../../../config/global.js";
    export default {
        name: "add-customer-product-buy-panel",
			data:function () {
				return {
					customerProduct:{
						customerId:null,
						productId:null,
						productCategoryId:null,
						portion:null,
						amount:null,
						buyTime:null,
						remark:null
					},
					productList:[],
					currentProduct:{},
					rules: {
						productId: [
							{ required: true, message: '请选择产品', trigger: 'blur' }
						],
						productCategoryId: [
							{ required: true, message: '请选择产品分类', trigger: 'blur' }
						],
						portion: [
							{ required: true, message: '请输入份额', trigger: 'blur' },
							{ type: 'number',min:1, message: '请输入份额', trigger: 'blur' }
						],
						amount: [
							{ required: true, message: '请输入金额', trigger: 'blur' },
							{type: 'number',min:0.01, message: '请输入金额', trigger: 'blur' }
						],
						// buyTime:[
						// 	{ required: true, message: '请输入购买日期', trigger: 'blur' }
						// ],
						remark: [
							{ max: 200, message: '请输入200以下个字符', trigger: 'blur' }
						],
					},
					operating:false,
				}
			},
			props:{
        customer:{}
			},
			activated:function () {
			},
			mounted:function () {
				this.listProduct();
			},
			methods:{
				listProduct(){
					axios({
						method: 'post',
						url:config.host+'/backend/product/list.json',
						data:{start:0,size:99,netValue:false,hasCategory:true}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						if(response.data.result == 1){
							this.productList = response.data.items;
						}else{
							this.$alert(response.data.emsg, '请求失败', {
								confirmButtonText: '确定'
							});
						}
						this.operating = false;
						console.log(response.data)
					}).catch((error)=>{
						this.operating = false;
						this.$alert(error.response.statusText, '请求失败', {
							confirmButtonText: '确定'
						});
					})
				},
				productIdChanged(){
					if(this.productList){
						this.productList.forEach(item=>{
							if(this.customerProduct.productId == item.id){
								this.currentProduct = item;
								return false;
							}
						});
					}
					this.customerProduct.productCategoryId = null;
				},
				submit:function () {
					this.$refs.addCustomerProductForm.validate((valid) => {
						if (valid) {
							this.customerProduct.customerId = this.customer.id;
							var customerProduct = JSON.parse(JSON.stringify(this.customerProduct));
							customerProduct.type = 1;
							this.operating = true;
							axios({
								method: 'post',
								url:config.host+'/backend/customer/buy.json',
								data:customerProduct
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '添加成功',
										type: 'success'
									});
									this.$emit('addcustomerproductsuccess');
								}else{
									this.$alert(response.data.emsg, '添加失败', {
										confirmButtonText: '确定'
									});
								}
								this.operating = false;
								console.log(response.data)
							}).catch((error)=>{
								this.operating = false;
								this.$alert(error.response.statusText, '添加失败', {
									confirmButtonText: '确定'
								});
							})
						} else {
							return false;
						}
					});
				}
			}
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/customer/AddCustomerProductBuyPanel.vue